import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import '../../Styles/Analysen Request/lvanalysestatus.css';
import uuid from 'react-uuid';

function ErrorComponent(props) {

    let [errors, setErrors] = useState([]);
    const [errorCount, setErrorCount] = useState([]);

    useEffect(() => {
        setErrorCount(props.logs.output[0].length);
        const err = props.logs.output[0];
        errors = err.map(e =>
            <div key={uuid()} className='err'>
                [{e.level}: {uuid()}] <br />
                {e.process} encountered an error at ord {e.oz} with: {e.traceback}
                <br /> <br />
            </div>
        );
        setErrors(errors);
    }, []);

    return (
        <>
            {errorCount > 0 && (
                <div className='row'>
                    <div className='console-type-error card col-md-12'>
                        {errors}
                    </div>
                </div>
            )}
        </>
    );
}

export default ErrorComponent;